// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import CardContent from './common/CardContent'
import Title from './common/Title'

const StoresCards = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;

	@media (max-width: 1280px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 599px) {
		grid-template-columns: 100%;
	}
`

const CardContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 25px;
	box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
	cursor: pointer;
`

const StyledTitle = styled(Title)`
	margin-top: 45px;
	margin-bottom: 20px;
	color: var(--strokeMenuTitle);

	@media (max-width: 576px) {
		margin-top: 30px;
		margin-bottom: 15px;
	}
`

const FullStoreList = ({ chainStores, locale, onSelectedStore, conversationText }) => (
	<>
		<StyledTitle>{conversationText.eCommerce.storeLocator.storeList}</StyledTitle>
		<StoresCards>
			{chainStores.msg.map?.((store) => (
				<CardContentContainer key={store.id} onClick={() => onSelectedStore(store)}>
					<CardContent data={store} locale={locale} isFullList conversationText={conversationText} />
				</CardContentContainer>
			))}
		</StoresCards>
	</>
)

export default FullStoreList
